import React from 'react';
import { numberChecker } from './StepWrapper';

export const Step1 = ({ dispatch, tvCount, isInternetOnly }) => {
  window.history.pushState("", "", '/checkout/konfigurirai');

  return (<>
    <h2 className='mb-5'>Конфигурирай</h2>
    <form className='popup-form'>
      <div className="form-row">
        {!isInternetOnly && (<div className="form-group col-md-7">
          <label htmlFor='tvCount'>Брой IPTV приемници</label>
          <input type="text" className="form-control" id='tvCount' placeholder="Въведете до 5 броя" value={tvCount} onChange={(v) => dispatch({
            type: 'field',
            field: 'tvCount',
            objField: 'hdFetcher',
            value: numberChecker(v.currentTarget.value) ? v.currentTarget.value : 1,
          })} />
          <small>При 6 и повече приемници, моля,<br /> позвънете на <a href='tel:0882991611'>088 299 1611</a> за индивидуална оферта.</small>
        </div>)}
        <div className="form-group col-md-7">
          <label htmlFor="contractLength">Срок на договора</label>
          <select id="contractLength" className="form-control" onChange={(v) => dispatch({
            type: 'field',
            field: 'contractLength',
            objField: 'duration',
            value: v.currentTarget.value,
          })}>
            <option selected value={2}>24 месеца</option>
            <option value={1}>12 месеца</option>
            {isInternetOnly && <option value={0}>безсрочен</option>}
          </select>
        </div>
      </div>
      <button className='btn btn-primary green mt-5' type="button" disabled={!isInternetOnly && tvCount === ''} onClick={(e) => {
        e.preventDefault();
        dispatch({ type: 'next_step' });
      }}>
        Следваща стъпка</button>
    </form>

  </>);
};
